import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/shared/data/data.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-blog-grid',
  templateUrl: './blog-grid.component.html',
  styleUrls: ['./blog-grid.component.scss']
})
export class BlogGridComponent implements OnInit {
  singleBlogPost: any[] = [];
  blogGrid: number = 1;
  totalCount = 0;
  currentPage = 1;
  pageSize = 6;
  totalItems = 0;
  totalPages = 0;
  p: number = 1;
  categories: any[] = [];
  selectedCategory: any = '';
  // baseUrl = this.blogService.data.base_url.replace('/api/', '/media/');

  @ViewChild('categoryBar', { static: false }) categoryBar!: ElementRef;

  scrollFilter(direction: 'left' | 'right') {
    if (this.categoryBar && this.categoryBar.nativeElement) {
      const container = this.categoryBar.nativeElement;
      const scrollAmount = 300;
      container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  }

  constructor(private http: HttpClient, private data: DataService,private meta: Meta,
        private titleService: Title,) { }
  // constructor(private blogService: BlogService) {}

  pageTitle = [
    {
      bgImage: '../../../../assets/img/slider/blogs.jpg',
      title: 'Kitchen Magic Blog'
    }
  ]


  ngOnInit(): void {

    this.titleService.setTitle(
            'Our Kitchen Magic Blogs'
        );

        this.meta.updateTag({
            name: 'description',
            content: 'Discover the delicious variety of blogs at Kitchen Magic, prepared with fresh ingredients and authentic flavors. From savory mains to delightful treats, explore our full menu and find your new favorite!'
        });

    this.loadBlogs();
    this.loadCategories();
  }

  loadCategories() {
    this.http.post<any>(
      this.data.base_url + 'get_blog_categories/',
      {}   // empty body for POST
    ).subscribe((res: any) => {
      if (res.status === 1) {
        // this.categories = res.data;
        this.categories = res.data.filter(
          (item: any) => item.status === 1
        );
      }
    }, (error) => {
      console.error('Error loading categories:', error);
    });
  }

  onCategoryChange(event: any) {
    this.selectedCategory = event.target.value;
    this.currentPage = 1;      // 👈 Reset to first page
    this.loadBlogs();          // 👈 Call API again
  }

  loadBlogs(): void {
    const payload = {
      page: this.currentPage,
      page_size: this.pageSize,
      category_id: this.selectedCategory
    };
    console.log('📤 Sending payload to backend:', payload);
    this.http.post<any>(
      this.data.base_url + 'get_blogs_all/',
      payload
    ).subscribe({
      next: (response: any) => {
        console.log('📥 Backend response:', response);
        if (response.status == 1 && response.data) {
          this.totalItems = response.total_count;
          this.totalPages = response.total_pages;
          this.singleBlogPost = response.data
            .filter((blog: any) =>
              blog.title &&
              blog.description &&
              blog.status === 1
            )
            .map((blog: any) => {
              return {
                id: blog.id,
                img: blog.image && blog.image !== ''
                  ? this.data.base_url + 'media/' + blog.image
                  : 'assets/img/blog/blog1.jpg',   // fallback image
                tag: 'Blog',
                title: blog.title,
                paragraph: blog.description,
                linkText: 'Read More',
                detailsLink: 'blog-details/' + blog.id
              };
            });
          console.log('✅ Blogs loaded:', this.singleBlogPost.length);
          console.log('📋 Blog array:', this.singleBlogPost);
        } else {
          console.warn('⚠️ No data in response or status != 1');
          this.singleBlogPost = [];
        }
      },
      error: (error) => {
        console.error('❌ Backend error:', error);
        this.singleBlogPost = [];
      }
    });
  }

  // onPageChange(page: number) {
  //   alert(page);
  //   this.blogGrid = page;
  //   this.loadBlogs();
  // }


  // onPageChange(page: number) {
  //   this.currentPage = page;
  //   this.loadBlogs();   // 🔥 call API again
  // }

  onPageChange(page: number) {
    this.p = page;          // important
    this.currentPage = page;
    this.loadBlogs();
  }


  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.loadBlogs();
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadBlogs();
    }
  }

  onCategorySelect(categoryId: any) {

    this.selectedCategory = categoryId;

    this.currentPage = 1;

    // this.getBlogs(categoryId);
    this.loadBlogs();
  }
}